<template>
  <span :class="'base-tag ' + typeTag + sizeTag">
    <slot /> <i v-if="closeTag" @click="handleClose()" class="el-icon-close" />
  </span>
</template>

<script>
export default {
  props: {
    type: String,
    size: String,
    value: {
      type: Object,
      default: () => {}
    },
    closeTag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    typeTag() {
      switch (this.type) {
        case 'success':
          return `text-${this.type} bgr-${this.type}`
        case 'warning':
          return `text-${this.type} bgr-${this.type}`
        case 'danger':
          return `text-${this.type} bgr-${this.type}`
        case 'info':
          return `text-${this.type} bgr-${this.type}`
        case 'complete':
          return `text-${this.type} bgr-${this.type}`
        default:
          return 'text-primary bgr-primary'
      }
    },
    sizeTag() {
      switch (this.size) {
        case 'mini':
          return ' tag-mini'
        case 'small':
          return ' tag-small'
        case 'medium':
          return ' tag-medium'
        default:
          return ' tag-small'
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-tag {
  border-radius: 30px;
  height: 100%;
  box-sizing: border-box;
  display: inline-block;
  font-weight: bold;
  .el-icon-close {
    cursor: pointer;
    padding-left: 3px;
  }
  .el-icon-close:hover{
    font-weight: bold;
    color: red;
  }
}

</style>